import { render, staticRenderFns } from "./inputdialog.vue?vue&type=template&id=679e65b8"
import script from "./inputdialog.vue?vue&type=script&lang=js"
export * from "./inputdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports